module.exports = __webpack_public_path__ + "assets/img/7icon.6eaaaa6b.png";